import { Block } from "baseui/block";
import { Button } from "baseui/button";
import { useStyletron } from "baseui";
import DownloadIcon from "assets/images/download-icon.svg";
import {
  COMMON_RADIUS,
  COMMON_BORDER_WIDTH,
  COMMON_BORDER_STYLE,
} from "utils/style";
import MyDocument from "./PdfExport";
import {
  PDFDownloadLink
  } from '@react-pdf/renderer';
import {
  Download_PDF,
  Dol_Checklist_Title,
} from "resources/constants/strings.js";

const BUTTON_OVERRIDE_STYLE = ({ $theme }) => ({
  backgroundColor: "white",
  ...COMMON_RADIUS("8px"),
  ...COMMON_BORDER_WIDTH("1px"),
  ...COMMON_BORDER_STYLE("solid"),
  borderColor: $theme.RAColors?.purple,
  paddingTop: "12px",
  paddingBottom: "12px",
  paddingRight: "24px",
  paddingLeft: "24px",
  ":hover": { backgroundColor: $theme.RAColors?.gray300 },
  color: $theme.RAColors?.purple,

  [$theme.mediaQuery.small]: {
    width: '100%',
  },
  [$theme.mediaQuery.medium]: {
    width: "initial",
  },
});
const DOWNLOAD_ICON_STYLE = {
  width: "12px",
  height: "12px",
  marginRight: "16px",
};
const TITLE_STYLE = theme => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: '16px',
  flexWrap: 'wrap',
  paddingLeft: "4px",
  paddingRight: "4px",
  [theme.mediaQuery.small]: {
    marginBottom: "16px",
  },
  [theme.mediaQuery.medium]: {
    marginBottom: "36px",
  },
});
const HEADING_STYLE = (theme) => ({
  fontFamily: "Epilogue-Semibold",
  fontSize: "28px",
  lineHeight: "40px",
  color: theme.RAColors?.gray900,
});

const Title = ({ exportPdf }) => {
  const [css, theme] = useStyletron();
  return (
    <Block className={css(TITLE_STYLE(theme))}>
       <Block as="h3" className={css(HEADING_STYLE(theme))} data-testid="title">
        {Dol_Checklist_Title}
      </Block>
      {/* <Button
        //onClick={exportPdf}
        overrides={{ BaseButton: { style: BUTTON_OVERRIDE_STYLE } }}
        data-testid="download-button"
      >
        <img
          src={DownloadIcon}
          alt="Download"
          className={css(DOWNLOAD_ICON_STYLE)}
        />
        <span></span>
        <PDFDownloadLink document={<MyDocument data={exportPdf}/>} fileName="dolchecklist.pdf">
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' : Download_PDF)}
    </PDFDownloadLink>
      </Button> */}
    </Block>
  );
};

export default Title;
